import _service from './api';
import _ from 'lodash';
import locationMessageCode from '@/utils/constants/messageLocationCode.js';
import applications from "@/utils/constants/applications";

const actions = {
  async getAlerts(context) {
    //Search again
    if (context.getters.getAlerts.length == 0) {
      const data = await _service.fetchAlerts();
      context.commit('setAlert', data);
    }
  },
  async getAlertsDetails({ commit }, filters) {
    const data = await _service.fetchAlertsByType(filters);
    commit('setAlertsDetails', data);
  },
  async getMessages({ commit, getters }) {
    const { data: response } = await _service.fetchMessages();
    if (response) {
      commit(
        'setMessage',
        _.chunk(
          response.filter(
            (s) => s.messageLocationCode === locationMessageCode.Lateral
          ),
          getters.getMessagesPerPage ? getters.getMessagesPerPage : 3
        )
      );
      commit(
        'setImmediateMessage',
        response.filter(
          (s) =>
            s.messageLocationCode === locationMessageCode.Inicio ||
            s.messageLocationCode === locationMessageCode.InicioConAcuse
        )
      );
    }
  },
  async getSchedule({ commit }, date) {
    const { data: response } = await _service.fetchSchedule(date, applications.Mipe);
    if (response) {
      commit('setSchedule', response);
    }
  },
  async saveReadMessage(_, messageRoleId, messageId) {
    return await _service.saveReadMessage(messageRoleId, messageId);
  },
};

export default actions;
